export const stripInput = value => {
  if (!value) {
    return false;
  }
  return value.replace(/\s/gi, '');
};
